import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames/bind'
import { RichText } from 'prismic'

import ThemeWaypoint from 'components/ui/ThemeWaypoint'
import HorizontalWrapper from '../HorizontalWrapper'

import s from './HeroQuote.module.scss'
const cn = classNames.bind(s)

const HeroQuote = ({ data }) => {
  const { primary } = data

  if (!primary) return null
  return (
    <HorizontalWrapper>
      <ThemeWaypoint after="dark" className={cn('waypoint')} />
      <div className={cn('inner')}>
        {primary.quote && (
          <div className={cn('quote')}>
            <div className="headlineHero">{RichText.render(primary.quote)}</div>
          </div>
        )}
      </div>
    </HorizontalWrapper>
  )
}

HeroQuote.propTypes = {
  data: PropTypes.object.isRequired,
}

export default HeroQuote
